import { useState, FormEvent } from 'react'
import { useAuth } from '@/hooks/useAuth'
import { Loader2 } from 'lucide-react'

export function LoginPage() {
  const { login, isLoggingIn, loginError } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [twoFactorCode, setTwoFactorCode] = useState('')
  const [needs2fa, setNeeds2fa] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    try {
      const res: any = await login({ email, password, twoFactorCode: needs2fa ? twoFactorCode : undefined })
      if (res?.requiresTwoFactor) {
        setNeeds2fa(true)
      }
    } catch {
      // erro tratado pelo loginError
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-100 to-brand-50 p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-brand-600 text-white text-2xl font-bold mb-4">M</div>
          <h1 className="text-2xl font-semibold text-slate-900">M365 Transfer</h1>
          <p className="text-sm text-slate-500 mt-1">Entre para gerenciar suas migrações</p>
        </div>

        <form onSubmit={onSubmit} className="card p-6 space-y-4">
          <div>
            <label className="label">E-mail</label>
            <input
              type="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              disabled={needs2fa}
            />
          </div>

          <div>
            <label className="label">Senha</label>
            <input
              type="password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={needs2fa}
            />
          </div>

          {needs2fa && (
            <div>
              <label className="label">Código 2FA (6 dígitos)</label>
              <input
                type="text"
                className="input tracking-[0.5em] text-center text-lg"
                value={twoFactorCode}
                onChange={(e) => setTwoFactorCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="000000"
                maxLength={6}
                autoFocus
                required
              />
            </div>
          )}

          {loginError && (
            <div className="rounded-md bg-red-50 border border-red-200 p-3 text-sm text-red-800">
              {(loginError as any).message || 'Erro ao fazer login'}
            </div>
          )}

          <button type="submit" className="btn-primary w-full" disabled={isLoggingIn}>
            {isLoggingIn && <Loader2 className="h-4 w-4 animate-spin" />}
            {needs2fa ? 'Verificar' : 'Entrar'}
          </button>
        </form>

        <p className="text-center text-xs text-slate-400 mt-6">
          Acesso restrito — operadores HAHOST
        </p>
      </div>
    </div>
  )
}
